import { render, staticRenderFns } from "./OxygenControls.vue?vue&type=template&id=1d38d69e&"
import script from "./OxygenControls.vue?vue&type=script&lang=ts&"
export * from "./OxygenControls.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenControls.vue?vue&type=style&index=0&id=1d38d69e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports